// extracted by mini-css-extract-plugin
module.exports = {"whereToBuy_pc":"WTB_whereToBuy_pc__DWN0Q"};